import { concatStyleSets, DefaultButton, Panel, PanelType, PrimaryButton, Stack } from '@fluentui/react';
import React, { useCallback, useMemo } from 'react';
import { useContext } from 'react';
import ImmocomContext from '../../contexts/ImmocomContext';
import { NotificationsTarget, useNotificationsManager } from '../../contexts/notificationContext';
import MessageBars from '../Layout/MessageBars';
import EUIIconButton from './EUIIconButton';

const EUIPanel = (props) => {

    // CONTEXTS
    const { clear } = useNotificationsManager();
    const { dismissAllMessages } = useContext(ImmocomContext); // A supprimer une fois la migration terminée

    // PROPS
    const {
        children = [],
        customDefaultButtons = [], // Boutons additionnels
        customPrimaryButtons = [], // Boutons additionnels
        farButtons = [],
        isFooterAtBottom = true,
        isFormValid = true,
        labelSave = "Enregistrer", /* 20230606 : YD : 2421 */
        onDelete = undefined, // SUPPRIMER
        onDismiss = undefined, // ANNULER
        onNext = undefined, // SUIVANT
        onOpen = undefined,
        onPrevious = undefined, // PRECEDENT
        onResetFilters = undefined, // Utilisé dans les PanelFiltres (remarque = peut-être créer un composant EUIPanelFiltre intermédiaire)
        onSave = undefined, // ENREGISTRER
        onSend = undefined, // ENVOYER
        onValidate = undefined, // VALIDER
        renderFooter = true,
        styles = {},
        type = PanelType.smallFixedFar,
    } = props;

    // MEMOS
    const _styles = useMemo(() => {
        return concatStyleSets(
            {
                closeButton: {
                    color: "white",
                    selectors: { "&:hover": { backgroundColor: "inherit", color: "white" } }
                },
                commands: { margin: "9px unset" },
                contentInner: { backgroundColor: "white" },
                headerText: { color: "white", fontWeight: "unset" },
                main: { backgroundColor: "red" },
            },
            styles
        );
    }, [styles])

    // METHODS
    const _onDismiss = useCallback((event) => {
        if (typeof onDismiss === "function")
            onDismiss(event);
    }, [onDismiss]);

    const _onOpen = useCallback((event) => {
        clear();
        dismissAllMessages(); // A supprimer une fois la migration terminée
        if (typeof onOpen === "function")
            onOpen(event);
    }, [onOpen]);

    const _onRenderFooterContent = useCallback(() => {

        const buttons = <Stack horizontal tokens={{ childrenGap: 8 }}>
            {!!onPrevious && <DefaultButton onClick={onPrevious}>Précédent</DefaultButton>}
            {!!onSave && <PrimaryButton id="btnSave" name="btnEnregistrer" onClick={onSave} disabled={!isFormValid}>{labelSave}</PrimaryButton>}
            {!!onValidate && <PrimaryButton id="btnValidate" name="btnValidate" onClick={onValidate} disabled={!isFormValid}>Valider</PrimaryButton>}
            {!!onSend && <PrimaryButton id="btnSend" name="btnSend" onClick={onSend} disabled={!isFormValid}>Envoyer</PrimaryButton>}
            {!!onNext && <PrimaryButton id="btnNext" name="btnNext" onClick={onNext} disabled={!isFormValid}>Suivant</PrimaryButton>}
            {!!onDelete && <PrimaryButton id="btnDelete" name="btnDelete" onClick={onDelete}>Supprimer</PrimaryButton>}
            {!!customPrimaryButtons && Array.isArray(customPrimaryButtons) && customPrimaryButtons}
            {!!customDefaultButtons && Array.isArray(customDefaultButtons) && customDefaultButtons}
            {!!onDismiss && <DefaultButton onClick={_onDismiss}>Fermer</DefaultButton>}
        </Stack>;

        if (!Array.isArray(farButtons) || farButtons.length === 0) return buttons;
        else return <Stack horizontal horizontalAlign="space-between">
            {buttons}
            <Stack horizontal tokens={{ childrenGap: 8 }}>{farButtons}</Stack>
        </Stack>;

    }, [customDefaultButtons, customPrimaryButtons, farButtons, isFormValid, labelSave, onDelete, onDismiss, onNext, onPrevious, onSave, onSend, onValidate]);

    const _onRenderHeader = useCallback((props, defaultRender) => {
        const defaultHeader = defaultRender(props);
        if (!!onResetFilters)
            return <Stack horizontal horizontalAlign="space-between" styles={{ root: { width: "100%" } }}>
                {defaultHeader}
                <EUIIconButton
                    ariaLabel="Filtres"
                    iconProps={{
                        iconName: 'ClearFilter',
                        styles: { root: { color: "white" } }
                    }}
                    onClick={onResetFilters}
                    title="Réinitialiser les filtres"
                />
            </Stack>;
        else return defaultHeader;
    }, [onResetFilters]);

    // RENDER
    return <Panel
        {...props}
        closeButtonAriaLabel="Fermer"
        isFooterAtBottom={isFooterAtBottom}
        onDismiss={_onDismiss}
        onOpen={_onOpen}
        onRenderFooterContent={renderFooter ? _onRenderFooterContent : null}
        onRenderHeader={_onRenderHeader}
        styles={_styles}
        type={type}
    >
        <div style={{ marginLeft: "-24px", marginRight: "-24px" }}>
            <MessageBars target={NotificationsTarget.panels} />
        </div>
        {children}
    </Panel>;

};

export { EUIPanel };